module.exports = __webpack_public_path__ + "img/bg_page_background_header.589d8c70.png";